import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { position, onDragEnded } from '@shared/helpers/dialog-drag-constraints';

@Component({
    selector: 'app-login-page-alert',
    templateUrl: './login-page-alert.component.html',
    styleUrls: ['./login-page-alert.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoginPageAlertComponent implements OnInit {
  static readonly componentName = 'LoginPageAlertComponent';
  
  public position = position;
  public onDragEnded = onDragEnded;

  constructor(
    @Inject(MAT_DIALOG_DATA) 
    public data: any,
    private dialogRef: MatDialogRef<LoginPageAlertComponent>,
    ) { }

  ngOnInit() {}
}
